import React from 'react';
import Cal from '@calcom/embed-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function CalendarTest() {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-2xl font-bold mb-6">Cal.com Embed Test</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card className="shadow-md">
          <CardHeader>
            <CardTitle>Embedded Calendar</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-[600px] w-full rounded-md overflow-hidden border">
              <Cal
                calLink="mquinton34/30min"
                style={{ width: '100%', height: '100%' }}
                config={{
                  name: 'Test Customer',
                  email: 'test@example.com',
                  notes:
                    'Customer Meeting with Test Customer\n\nThis is a test of the Cal.com embed component',
                  layout: 'week_view',
                }}
              />
            </div>
          </CardContent>
        </Card>

        <Card className="shadow-md">
          <CardHeader>
            <CardTitle>Calendar Instructions</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p>
              This page demonstrates the Cal.com calendar integration using the official
              @calcom/embed-react package. The calendar should load and function properly.
            </p>

            <h3 className="font-medium text-lg mt-4">Integration Steps:</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Verify the calendar loads correctly on this page</li>
              <li>Confirm it works with the Cal.com account for DomElec</li>
              <li>Test booking a meeting (either phone call or site assessment)</li>
              <li>Keep meeting names flexible (avoid hard-coding "Site Assessment")</li>
              <li>Implement in the pipeline page for all customers</li>
            </ol>

            <Button className="mt-4 w-full" onClick={() => window.history.back()}>
              Return to Pipeline
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
